import branchManagementImportFileViewComponent from './import_file_view.component';

let branchManagementImportFileViewModule = angular.module('branchManagementImportFileView', [])
  .component('branchManagementImportFileView', branchManagementImportFileViewComponent)
  .name;

export default branchManagementImportFileViewModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/import_file_view/index.js